import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ReactNode } from 'react';
import useDayjsLocale from '../hooks/useDayjsLocale';

interface LocalizationWrapperProps {
  children: ReactNode;
}

const LocalizationWrapper: React.FC<LocalizationWrapperProps> = ({ children }) => {
  const locale = useDayjsLocale();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      {children}
    </LocalizationProvider>
  );
};

export default LocalizationWrapper;
